/**
 * Do not forget to use Save wherever you reference this mixin.
 *
 * <FadeTransition>
 *  <SaveButton v-show="unsavedChanges" @save="save" />
 * </FadeTransition>
 *
 * Not necessary to be used with the FadeTransition component,
 * but it makes things look smoother and it is advised.
 *
 * TODO: Find a programmatic way to check if the template of the
 * document the mixin is referenced by has included the SaveButton
 * in one way or another.
 */

import SaveButton from "@/components/SaveButton";
import FadeTransition from "@/components/transitions/FadeTransition";

export default {
  components: {
    SaveButton,
    FadeTransition
  },
  data() {
    return {
      initialValue: null,
      trackableVariableName: null,
      saveAction: null
    };
  },
  computed: {
    unsavedChanges() {
      return (
        this.initialValue !== JSON.stringify(this[this.trackableVariableName])
      );
    }
  },
  methods: {
    save() {
      if (this.saveAction) this.$store.dispatch(this.saveAction);

      this.$notify({
        type: "success",
        group: "foo",
        text: "Changes saved!"
      });
      this.track(this.trackableVariableName);
    },
    /**
     * Use this method to interface with the unsaved changes feature.
     * There is nothing more to use solely for tracking the changes,
     * but it will be usefull to use the SaveButton as explained at
     * the top of the document.
     *
     * @param {*} dataToBeTracked name of the variable to be tracked
     * @param {*} saveAction name of the save action in the store
     */
    track(dataToBeTracked, saveAction) {
      this.initialValue = JSON.stringify(this[dataToBeTracked]);
      this.trackableVariableName = dataToBeTracked;
      this.saveAction = saveAction;
    },
    onUnsavedChanges(next) {
      if (
        confirm(
          "You have not saved the changes. Are you sure you want to leave?"
        )
      ) {
        next();
      } else {
        try {
          next(false);
        } catch (e) {
          console.log(e);
        }
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.unsavedChanges) {
      this.onUnsavedChanges(next);
    } else {
      next();
    }
  }
};
